module.exports = __webpack_public_path__ + "img/contact-right.0daca99c.png";